// Curso grátis do Culturaverso: revelações, terminais que digitam, abas por sistema, botões de copiar,
// teclado de comandos, cena da bola (física real: g = 9,8 m/s²) e barra de progresso.
// Sem JS tudo aparece inteiro e parado. Com movimento reduzido, tudo vai direto ao estado final, sem laço.
(() => {
  if (window.__cvcCurso) return;
  window.__cvcCurso = true;

  const raiz = document.documentElement;
  const reduzido = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const temIO = 'IntersectionObserver' in window;
  const mov = !reduzido && temIO;
  raiz.classList.add('cvc-js');
  if (mov) raiz.classList.add('cvc-mov');

  const espera = (ms) => new Promise((r) => setTimeout(r, ms));
  const $$ = (sel, el = document) => [...el.querySelectorAll(sel)];
  const fmt = (x, casas) => x.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });

  function quandoVisivel(el, fn, threshold = 0.3) {
    if (!temIO) { fn(); return; }
    const io = new IntersectionObserver((itens) => {
      for (const it of itens) if (it.isIntersecting) { io.disconnect(); fn(); break; }
    }, { threshold });
    io.observe(el);
  }

  // Região viva para avisar "copiado" a leitores de tela
  let avisoVivo;
  function avisa(txt) {
    if (!avisoVivo) {
      avisoVivo = document.createElement('div');
      avisoVivo.setAttribute('aria-live', 'polite');
      avisoVivo.className = 'cvc-sr';
      document.body.append(avisoVivo);
    }
    avisoVivo.textContent = '';
    setTimeout(() => { avisoVivo.textContent = txt; }, 30);
  }

  // ---------- Terminal com roteiro ----------
  // Linhas .cvc-l (e eventos .cvc-ev) aparecem em ordem. data-dig: digita o .cvc-cmd. data-pausa: espera antes (ms).
  // data-vel: ms por letra. data-estado: muda o data-estado do [data-cvc-palco]. data-passo: acende as etapas até N.
  function criaRoteiro(corpo) {
    const itens = $$('.cvc-l, .cvc-ev', corpo);
    const palco = corpo.closest('[data-cvc-palco]');
    const estadoFinal = palco ? palco.dataset.estado : null;
    // classes est-* acumulam os estados já vistos (o HTML já vem com as do estado final)
    const estFinais = palco ? [...palco.classList].filter((c) => c.startsWith('est-')) : [];
    let vez = 0;
    itens.forEach((l) => {
      const c = l.querySelector('.cvc-cmd');
      if (c && l.hasAttribute('data-dig')) l._txt = c.textContent;
    });
    const restaura = (l) => { if (l._txt != null) l.querySelector('.cvc-cmd').textContent = l._txt; };
    const luzes = (n) => {
      if (!palco) return;
      $$('[data-cvc-passo]', palco).forEach((p) => p.classList.toggle('is-aceso', n > 0 && +p.dataset.cvcPasso <= n));
    };
    const estado = (v) => {
      if (!palco || !v) return;
      palco.dataset.estado = v;
      palco.classList.add('est-' + v);
      palco.dispatchEvent(new CustomEvent('cvc:estado', { detail: v }));
    };
    function preparar() {
      vez++;
      itens.forEach((l) => { restaura(l); l.classList.remove('cvc-l--agora'); l.classList.add('cvc-l--espera'); });
      luzes(0);
      if (palco) [...palco.classList].filter((c) => c.startsWith('est-')).forEach((c) => palco.classList.remove(c));
      estado('inicio');
    }
    function mostrarTudo() {
      vez++;
      itens.forEach((l) => { restaura(l); l.classList.remove('cvc-l--espera', 'cvc-l--agora'); });
      luzes(99);
      estado(estadoFinal);
      if (palco) estFinais.forEach((c) => palco.classList.add(c));
    }
    async function tocar() {
      preparar();
      const minha = vez;
      for (const l of itens) {
        const dig = l.hasAttribute('data-dig');
        await espera(l.dataset.pausa ? +l.dataset.pausa : dig ? 420 : 260);
        if (minha !== vez) return;
        if (l.dataset.passo) luzes(+l.dataset.passo);
        if (l.dataset.estado) estado(l.dataset.estado);
        l.classList.remove('cvc-l--espera');
        if (!dig) continue;
        const c = l.querySelector('.cvc-cmd');
        const txt = l._txt;
        const feito = document.createElement('span');
        const falta = document.createElement('span');
        feito.className = 'cvc-feito';
        falta.className = 'cvc-falta';
        falta.textContent = txt;
        c.textContent = '';
        c.append(feito, falta);
        l.classList.add('cvc-l--agora');
        const vel = +l.dataset.vel || 38;
        for (let i = 1; i <= txt.length; i++) {
          if (minha !== vez) return;
          feito.textContent = txt.slice(0, i);
          falta.textContent = txt.slice(i);
          await espera(vel * (0.6 + Math.random() * 0.8) + (txt[i - 1] === ' ' ? vel : 0));
        }
        await espera(280);
        if (minha !== vez) return;
        l.classList.remove('cvc-l--agora');
        c.textContent = txt;
      }
    }
    return { tocar, preparar, mostrarTudo };
  }

  // ---------- Cena da bola (prévia do Studio) ----------
  function criaCena(palco) {
    const svg = palco.querySelector('[data-cvc-cena]');
    if (!svg) return;
    const bola = svg.querySelector('[data-cena="bola"]');
    const sombra = svg.querySelector('[data-cena="sombra"]');
    const hud = { t: svg.querySelector('[data-hud="t"]'), v: svg.querySelector('[data-hud="v"]'), h: svg.querySelector('[data-hud="h"]') };
    const linha = palco.querySelector('.cvc-linha-tempo');
    const quadro = palco.querySelector('[data-quadro]');
    const G = 9.8, H0 = 10, E = 0.6, DUR = 5, FPS = 30;
    const T1 = Math.sqrt((2 * H0) / G);
    function fisica(t) {
      if (t < T1) return { h: H0 - 0.5 * G * t * t, v: G * t };
      let resto = t - T1;
      let sobe = E * G * T1;
      while (sobe > 0.25) {
        const voo = (2 * sobe) / G;
        if (resto < voo) return { h: sobe * resto - 0.5 * G * resto * resto, v: Math.abs(sobe - G * resto) };
        resto -= voo;
        sobe *= E;
      }
      return { h: 0, v: 0 };
    }
    function desenha(t) {
      const { h, v } = fisica(t);
      bola.setAttribute('transform', `translate(120 ${(262 - 13 - h * 18).toFixed(2)})`);
      const k = 1 - h / H0;
      sombra.setAttribute('rx', (6 + 8 * k).toFixed(2));
      sombra.setAttribute('opacity', (0.12 + 0.3 * k).toFixed(3));
      hud.t.textContent = fmt(t, 2);
      hud.v.textContent = fmt(v, 1);
      hud.h.textContent = fmt(Math.max(0, h), 1);
      if (linha) linha.style.setProperty('--cvc-t', (t / DUR).toFixed(4));
      if (quadro) quadro.textContent = Math.min(DUR * FPS, Math.floor(t * FPS));
    }
    let rodando = false, visivel = false, t0 = 0, raf = 0;
    const deveRodar = () => mov && visivel && ['cena', 'render', 'pronto'].includes(palco.dataset.estado);
    const laco = (agora) => {
      if (!rodando) return;
      desenha(((agora - t0) / 1000) % DUR);
      raf = requestAnimationFrame(laco);
    };
    const confere = () => {
      if (deveRodar()) {
        if (!rodando) { rodando = true; t0 = performance.now(); raf = requestAnimationFrame(laco); }
      } else if (rodando) { rodando = false; cancelAnimationFrame(raf); }
    };
    if (temIO) new IntersectionObserver(([it]) => { visivel = it.isIntersecting; confere(); }).observe(svg);
    if (mov) desenha(0);
    palco.addEventListener('cvc:estado', (ev) => {
      if (ev.detail === 'cena' && rodando) t0 = performance.now();
      if (ev.detail === 'inicio' || ev.detail === 'studio') desenha(0);
      confere();
    });
  }

  function animaRender(palco) {
    const caixa = palco.querySelector('.cvc-render');
    const n = palco.querySelector('[data-render-n]');
    if (!caixa) return;
    const t0 = performance.now(), dur = 2300;
    const passo = (agora) => {
      const k = Math.min(1, (agora - t0) / dur);
      caixa.style.setProperty('--cvc-r', k.toFixed(3));
      if (n) n.textContent = Math.round(150 * k);
      if (k < 1 && palco.dataset.estado === 'render') requestAnimationFrame(passo);
    };
    requestAnimationFrame(passo);
  }

  // ---------- Caixa de prompt do app: d1/d2/d3 digitam, e1/e2/e3 enviam ----------
  function criaCaixa(palco) {
    const caixa = palco.querySelector('.cvc-caixa--digita');
    if (!caixa) return;
    const spans = $$('.cvc-caixa__dig', caixa);
    let vez = 0;
    const limpa = () => { vez++; spans.forEach((sp) => { sp.textContent = ''; }); caixa.classList.remove('tem-texto'); };
    palco.addEventListener('cvc:estado', async (ev) => {
      const m = /^([de])(\d)$/.exec(ev.detail || '');
      if (!m) { if (ev.detail === 'inicio' || ev.detail === palco.dataset.final) limpa(); return; }
      const sp = caixa.querySelector('.cvc-caixa__dig--' + m[2]);
      if (!sp) return;
      if (m[1] === 'e') { limpa(); return; }
      const minha = ++vez;
      const txt = sp.dataset.texto || '';
      caixa.classList.add('tem-texto');
      for (let i = 1; i <= txt.length; i++) {
        if (minha !== vez) return;
        sp.textContent = txt.slice(0, i);
        await espera(22 + Math.random() * 26);
      }
    });
  }

  // ---------- Vídeo de introdução ----------
  function criaVideo(escopo) {
    $$('.cvc-video', escopo).forEach((caixa) => {
      const v = caixa.querySelector('video');
      const b = caixa.querySelector('button.cvc-video__play');
      if (!v || !b) return;
      b.addEventListener('click', () => { caixa.classList.add('is-tocando'); v.play().catch(() => { caixa.classList.remove('is-tocando'); }); v.focus({ preventScroll: true }); });
      v.addEventListener('play', () => caixa.classList.add('is-tocando'));
    });
  }

  // ---------- Abas por sistema ----------
  function criaAbas(caixa) {
    const abas = $$('[role="tab"]', caixa);
    const paineis = abas.map((a) => document.getElementById(a.getAttribute('aria-controls')));
    let visto = false;
    const roteiroDe = (i) => paineis[i] && paineis[i].querySelector('[data-cvc-roteiro]')?._roteiro;
    function escolhe(i, foco) {
      abas.forEach((a, j) => {
        const sel = i === j;
        a.setAttribute('aria-selected', String(sel));
        a.tabIndex = sel ? 0 : -1;
        if (paineis[j]) paineis[j].hidden = !sel;
      });
      if (foco) abas[i].focus();
      const r = roteiroDe(i);
      if (r && visto) (mov ? r.tocar() : r.mostrarTudo());
    }
    abas.forEach((a, i) => {
      a.addEventListener('click', () => escolhe(i));
      a.addEventListener('keydown', (ev) => {
        const ir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[ev.key];
        if (ir) { ev.preventDefault(); escolhe((i + ir + abas.length) % abas.length, true); }
        else if (ev.key === 'Home') { ev.preventDefault(); escolhe(0, true); }
        else if (ev.key === 'End') { ev.preventDefault(); escolhe(abas.length - 1, true); }
      });
    });
    const ehWindows = /Windows/i.test(navigator.userAgent);
    const inicial = ehWindows ? Math.max(0, abas.findIndex((a) => a.dataset.so === 'ps')) : 0;
    escolhe(inicial);
    quandoVisivel(caixa, () => {
      visto = true;
      const i = abas.findIndex((a) => a.getAttribute('aria-selected') === 'true');
      const r = roteiroDe(i);
      if (r) (mov ? r.tocar() : r.mostrarTudo());
    }, 0.35);
  }

  // ---------- Copiar ----------
  function copiaVelho(txt) {
    const ta = document.createElement('textarea');
    ta.value = txt;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
    document.body.append(ta);
    ta.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    ta.remove();
    return ok;
  }
  document.addEventListener('click', async (ev) => {
    const b = ev.target.closest('.cvc-copiar');
    if (!b) return;
    const caixa = b.closest('[data-copia-caixa]');
    const txt = b.dataset.copia ?? caixa?.querySelector('[data-copia-texto]')?.textContent.trim();
    if (!txt) return;
    let ok = false;
    try { await navigator.clipboard.writeText(txt); ok = true; } catch (e) { ok = copiaVelho(txt); }
    const rot = b.querySelector('[data-copia-rotulo]');
    if (b._rotulo == null) b._rotulo = rot.textContent;
    rot.textContent = ok ? 'copiado!' : 'não deu: selecione e copie';
    b.classList.toggle('is-copiado', ok);
    avisa(ok ? 'Copiado' : 'Não foi possível copiar');
    clearTimeout(b._t);
    b._t = setTimeout(() => { rot.textContent = b._rotulo; b.classList.remove('is-copiado'); }, 1800);
  });

  // ---------- Teclado de comandos ----------
  function criaTeclado(caixa) {
    const teclas = $$('.cvc-tecla', caixa);
    const tela = caixa.querySelector('[data-tela]');
    const cmd = caixa.querySelector('[data-tela-cmd]');
    const expl = caixa.querySelector('[data-tela-expl]');
    if (!teclas.length || !cmd || !expl) return;
    let vez = 0, auto = 0, mexeu = false, atual = 0;
    async function mostra(i) {
      atual = i;
      const minha = ++vez;
      teclas.forEach((t, j) => t.setAttribute('aria-pressed', String(i === j)));
      const k = teclas[i].querySelector('kbd').textContent;
      const x = teclas[i].dataset.explica;
      if (!mov) { cmd.textContent = k; expl.textContent = x; return; }
      cmd.textContent = '';
      expl.style.opacity = '0';
      for (let n = 1; n <= k.length; n++) {
        if (minha !== vez) return;
        cmd.textContent = k.slice(0, n);
        await espera(60);
      }
      await espera(150);
      if (minha !== vez) return;
      expl.textContent = x;
      expl.style.opacity = '1';
    }
    const paraAuto = () => { clearInterval(auto); auto = 0; };
    const ligaAuto = () => { if (!mexeu && !auto && mov) auto = setInterval(() => mostra((atual + 1) % teclas.length), 3800); };
    teclas.forEach((t, i) => t.addEventListener('click', () => {
      mexeu = true;
      paraAuto();
      if (tela) tela.setAttribute('aria-live', 'polite');
      mostra(i);
    }));
    if (mov) new IntersectionObserver(([it]) => (it.isIntersecting ? ligaAuto() : paraAuto()), { threshold: 0.4 }).observe(caixa);
  }

  // ---------- Vídeos: só tocam na tela ----------
  function criaVideos(escopo) {
    const vids = $$('video[data-cvc-video]', escopo);
    if (!vids.length) return;
    if (!mov) { vids.forEach((v) => { v.controls = true; }); return; }
    const io = new IntersectionObserver((itens) => {
      for (const it of itens) {
        const v = it.target;
        if (it.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          v.play().catch(() => {});
        } else v.pause();
      }
    }, { threshold: 0.35 });
    vids.forEach((v) => { v.controls = false; v.muted = true; io.observe(v); });
  }

  // ---------- Barra de progresso (o Horizon rola dentro de .page-wrapper no desktop) ----------
  function criaProgresso() {
    const barra = document.querySelector('.cvc-progresso');
    if (!barra || barra._ligada) return;
    barra._ligada = true;
    barra.classList.add('is-ligada');
    const main = document.getElementById('MainContent') || document.body;
    let pendente = false;
    const calcula = () => {
      pendente = false;
      const r = main.getBoundingClientRect();
      const total = r.height - innerHeight;
      const p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      barra.style.setProperty('--cvc-p', p.toFixed(4));
    };
    const pede = () => { if (!pendente) { pendente = true; requestAnimationFrame(calcula); } };
    document.addEventListener('scroll', pede, { capture: true, passive: true });
    addEventListener('resize', pede, { passive: true });
    calcula();
  }

  // ---------- Início (também quando o editor do tema recarrega uma seção) ----------
  function iniciar(escopo) {
    $$('[data-cvc-palco]', escopo).forEach((palco) => { if (!palco.dataset.final) palco.dataset.final = palco.dataset.estado || ''; });
    const revelar = $$('.cvc-entra', escopo);
    if (!mov) revelar.forEach((el) => el.classList.add('cvc-on'));
    else {
      const io = new IntersectionObserver((itens) => {
        for (const it of itens) if (it.isIntersecting) { it.target.classList.add('cvc-on'); io.unobserve(it.target); }
      }, { rootMargin: '0px 0px -8% 0px' });
      revelar.forEach((el) => io.observe(el));
    }

    $$('[data-cvc-roteiro]', escopo).forEach((corpo) => {
      const r = criaRoteiro(corpo);
      corpo._roteiro = r;
      if (!mov) { r.mostrarTudo(); return; }
      r.preparar();
      if (!corpo.closest('[data-cvc-abas]')) quandoVisivel(corpo, () => r.tocar(), 0.35);
    });
    $$('[data-cvc-abas]', escopo).forEach(criaAbas);

    $$('[data-cvc-palco]', escopo).forEach((palco) => {
      criaCena(palco);
      criaCaixa(palco);
      palco.addEventListener('cvc:estado', (ev) => { if (ev.detail === 'render') animaRender(palco); });
      const b = palco.querySelector('[data-cvc-repetir]');
      if (b) {
        if (!mov) b.hidden = true;
        else b.addEventListener('click', () => palco.querySelector('[data-cvc-roteiro]')?._roteiro?.tocar());
      }
    });

    $$('[data-cvc-teclado]', escopo).forEach(criaTeclado);
    criaVideos(escopo);
    criaVideo(escopo);
  }

  iniciar(document);
  criaProgresso();
  document.addEventListener('shopify:section:load', (ev) => { iniciar(ev.target); criaProgresso(); });
})();
